import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'strugglesSounds'

export default function StrugglesSoundsPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    // Get the answer value from the form
    const formData = new FormData(event.currentTarget)
    const selectedValue = formData.get('answer') as string

    if (!selectedValue) return

    const answer = {
      question_key: QUESTION_KEY,
      question: t('pages.onboarding.struggles.heading', { lng: 'en' }),
      answer_key: selectedValue,
      answer: selectedValue,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  // Struggles options
  const getStrugglesOptions = () => [
    {
      value: 'Trouble falling asleep',
      translationKey: 'pages.onboarding.struggles.options.trouble',
      emoji: '😵',
    },
    {
      value: 'Waking up in the night',
      translationKey: 'pages.onboarding.struggles.options.wakeUp',
      emoji: '🌙',
    },
    {
      value: 'Feeling tired in the morning',
      translationKey: 'pages.onboarding.struggles.options.tired',
      emoji: '😴',
    },
    {
      value: 'Going to bed too late',
      translationKey: 'pages.onboarding.struggles.options.goingToBed',
      emoji: '⏰',
    },
    {
      value: 'Just curious to improve',
      translationKey: 'pages.onboarding.struggles.options.curious',
      emoji: '🤔',
    },
  ]

  // Get the options
  const options = getStrugglesOptions()

  // Transform options to the format expected by QuestionPage
  const buttons = options.map((option) => ({
    text: `${option.emoji} ${t(option.translationKey)}`,
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.struggles.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
    />
  )
}
